import { type } from "@/api/arktype";

export const AuthSchemas = {
	login: type({
		name: type("string >= 1").pipe((value) => value.trim().toLowerCase()),
		password: "string >= 1",
	}),

	changePassword: type({
		new_password: "string >= 8",
	}),
};
